module.exports = __webpack_public_path__ + "static/profil_pic-4f03c34e1cbcdd188f0e12fdd83d8a97.png";